import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./journaldetails.module.css";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import { ArrowLeft, Edit, Home, MoreVertical, Trash2, X } from "react-feather";
import axios from "axios";
import dayjs from "dayjs";
import { Link, useHistory } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Dropdown } from "react-bootstrap";
import Loader from "../../../../components/Loader";
import Footer from "../../../../components/Footer";
import { TableLoaderSmall } from "../../../../components/LoaderC";
import AddJournal from "../AddJournal";
import MobileJournalView from "./components/MobileJournalView";
import VideoThumbnail from "./VideoThumbnail";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";

const JournalDetails = ({ history, match }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const { id } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [openEditForm, setOpenEditForm] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [journalDetails, setJournalDetails] = useState(null);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [propertyList, setPropertyList] = useState([]);
    const [tenantList, setTenantList] = useState([]);

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journal-property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => { });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchTenants() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/property-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let tFinalList = [];
                let tFinalList2 = [];

                let templistNew = response.data.data;

                templistNew?.map((item) => {
                    tFinalList.push({ label: item.label, parent: 1 });
                    item?.options?.map((subItem) => {
                        tFinalList.push({
                            value: subItem.value,
                            label: subItem.label,
                            parent: 0,
                            propertyId: item?.id,
                        });
                        return false;
                    });

                    return false;
                });

                templistNew?.map((item) => {
                    item?.options?.map((subItem) => {
                        tFinalList2.push({
                            group_id: item?.id,
                            group: item?.label,
                            value: subItem?.value,
                            label: subItem.label
                        });
                        return false;
                    });

                    return false;
                });

                setTenantList(tFinalList2);
            }).catch((error) => { });
        }

        fetchTenants();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const geNotificationDetails = async () => {
            setContentLoading(true);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journals/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setJournalDetails(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        geNotificationDetails();
    }, [getAccessTokenSilently, id]);

    const deleteConfirm = async () => {
        setLoading(true);
        setDeleteModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_TENANT_API_URL + 'v1/journals/' + id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setTimeout(() => {
                redirect.push("/security/journal/list");
            }, 2000);
        }).catch(error => {
            setLoading(false);
        });
    }

    const updateJournal = (data) => {
        setJournalDetails(data);
    }

    const videoExtensions = ["mp4", "mov", "avi", "mkv", "webm"];

    return (<>
        {loading && <Loader />}

        <Helmet title={"Journal Details"} />

        <div className={`${styles.mainCard}`}>
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Security</li>
                            <li className={`${styles.breadcrumbItem}`}><Link to={"/security/journal/list"}>Journals</Link></li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>Details</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link to={"/security/journal/list"} className={`${styles.BackArrow}`}><ArrowLeft /></Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>Journal details</Typography>
                        </div>
                    </div>
                </div>

                {contentLoading && (<div className="Loader TableLoader">
                    <TableLoaderSmall />
                </div>)}

                {!contentLoading && (<>
                    <div className={`${styles.SMProCusSmallDiv}`}>
                        <div className={`${styles.CardSmall}`}>
                            {journalDetails?.images?.length > 0 && <div className={`${styles.RequestCarouselSec} RequestCarouselSec`}>
                                <Carousel autoPlay={true} showThumbs={false} showArrows={false} showStatus={false} interval="3000">
                                    {journalDetails?.images?.map((item, index) => {
                                        const extension = item?.image_url.split(".").pop().split("?")[0].toLowerCase();
                                        return (videoExtensions.includes(extension)) ? (<div onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }}>
                                            <VideoThumbnail videoUrl={item?.image_url} />
                                        </div>) : (<div onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }}>
                                            <img src={item?.image_url} alt="" />
                                        </div>)
                                    })}
                                </Carousel>
                            </div>}
                            {/* {journalDetails?.images?.length === 0 && <div className={`${styles.RequestCarouselSec} RequestCarouselSec`}>
                                <div>
                                    <img src={"/static/img/journalImg1.jpg"} alt="" style={{ width: '100%' }} />
                                </div>
                            </div>} */}
                            <ul className={`${styles.CaseSummSideUL}`}>
                                <li>
                                    <p className={`${styles.ULtitle}`}>Any unusual activities or events to report</p>
                                    <p className={`${styles.ULData}`}>{journalDetails?.is_unusual === 1 ? "Yes" : "No"}</p>
                                </li>
                                <li>
                                    <p className={`${styles.ULtitle}`}>Submitted Date</p>
                                    <p className={`${styles.ULData}`}>{dayjs(journalDetails?.date).format("MM/DD/YYYY")}</p>
                                </li>
                                <li>
                                    <p className={`${styles.ULtitle}`}>Property</p>
                                    <p className={`${styles.ULData}`}>{journalDetails?.property_name}</p>
                                </li>
                                <li>
                                    <p className={`${styles.ULtitle}`}>Tenant(s)</p>
                                    <p className={`${styles.ULData}`}>{journalDetails?.tenant_names}</p>
                                </li>
                            </ul>
                            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 || user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1) && <Dropdown className={`${styles.ProEditSec}`}>
                                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                                    <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setOpenEditForm(true)}>
                                        <Edit /> Edit
                                    </Dropdown.Item>}
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen(true)}>
                                        <Trash2 /> Delete
                                    </Dropdown.Item>}
                                </Dropdown.Menu>
                            </Dropdown>}
                        </div>
                    </div>

                    <div className={`${styles.SMReferDeBigDiv}`}>
                        <div className={`${styles.Card}`}>
                            <div className={`${styles.cardbody}`} dangerouslySetInnerHTML={{ __html: journalDetails?.description }}></div>
                        </div>
                    </div>
                </>)}

            </div>
        </div>

        <MobileJournalView journalDetails={journalDetails} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setOpenEditForm={setOpenEditForm.bind(this)} />

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the journal?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The journal will be removed immediately. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</button>
                <button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openEditForm}
            onClose={(e) => setOpenEditForm(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenEditForm(false)}><ArrowLeft /></button>
                Edit Journal
                <button onClick={(e) => setOpenEditForm(false)}><X /></button>
            </DialogTitle>
            <DialogContent className={`${styles.RequestBodyPop}`}>
                <AddJournal journalData={journalDetails} propertyList={propertyList} allTenantList={tenantList} setOpenAddForm={setOpenEditForm.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={updateJournal.bind(this)} />
            </DialogContent>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            index={lightboxIndex}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={journalDetails?.images?.map(i => {
                const extension = i?.image_url.split(".").pop().split("?")[0].toLowerCase();
                if (videoExtensions.includes(extension)) {
                    return {
                        type: "video",
                        sources: [
                            {
                                src: i?.image_url
                            },
                        ]
                    }
                }
                return { src: i?.image_url }
            })}
            plugins={[Video]}
        />

        <Footer />
    </>);
};

export default withAuthenticationRequired(JournalDetails, {
    onRedirecting: () => <Loader />,
});